import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { SMARTBAR_TRANSLATIONS, SmartbarTranslations } from '@hdms/shared/ui-core';

export const SMARTBAR_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: SMARTBAR_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): SmartbarTranslations => ({
    ariaLabel: i18NextService.t('smartbar.ariaLabel')
  })
};
